import React, {useEffect, useContext} from 'react'
import {
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField,
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import {Autocomplete} from '@material-ui/lab'
import {ReservationConfigurationContext} from '../../../context/ReservationConfiguration'
import {useParams} from 'react-router'

const FTextField = ({data, onChange = (e, key, value) => {}}) => {
  let timeOptions = ['Yes', 'No']
  const {additionalFieldValues, getAdditionalFieldValues} = useContext(
    ReservationConfigurationContext
  )
  const {group_id} = useParams()
  useEffect(() => {
    getAdditionalFieldValues(group_id, ['NumericField', 'CurrencyField'], true, true, false)
  }, [group_id, getAdditionalFieldValues])
  return (
    <>
      <Autocomplete
        multiple
        options={additionalFieldValues.data.data?.fields.map(option => option.name) || []}
        id="standard-required"
        label=""
        renderInput={params => (
          <TextField
            {...params}
            variant="standard"
            label="Calculation Formula"
            placeholder=""
            onKeyPress={event => {
              if (event.key === 'Enter') {
              }
            }}
          />
        )}
      />
      <Button>Clear Formula</Button>
      <br />
      <FormControl variant="outlined" className="ap-textfield" style={{width: 200, marginTop: 16}}>
        <InputLabel id="">Display in Days, Hours and Minutes</InputLabel>
        <Select
          labelId=""
          id=""
          label="Display in Days, Hours and Minutes"
          value={data?.display_days}
          onChange={onChange}
          style={{width: '200px'}}
        >
          {timeOptions.map(opt => {
            return <MenuItem value={opt}>{`${opt}`}</MenuItem>
          })}
        </Select>
      </FormControl>
      <br />
    </>
  )
}

export default FTextField
